
require.register("vuelidate/lib/validators/alpha.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "vuelidate");
  (function() {
    "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = require("./common");

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;
  })();
});